<template>
  <div>
    <main>
      <!-- VINOVEST (old design) -->
      <div v-if="isVinovest" class="vinovest wineclub">
        <section class="thankyou">
          <header>
            <img
              class="vinovest-intro-logo-stamp fade-in"
              src="~/assets/images/logo-vinovestwineclub.svg"
              alt="Vinovest Membership Wine Club Logo"
            />
            <h1>
              {{ planInfo.thank_you_heading }}
            </h1>
          </header>
          <div class="copy">
            <p>
              {{ planInfo.thank_you_description }}
            </p>
            <p v-if="planStatusCopy">
              {{ planStatusCopy }}
            </p>
          </div>
          <div class="thankyou-customerservice">
            <div class="copy">
              <p>
                If you’d like to change your subscription or if you have
                questions, please contact us at
                <a
                  :href="`mailto:vinovest.${metadata.customerService.clubEmail}`"
                  >vinovest.{{ metadata.customerService.clubEmail }}</a
                >
                or <CustomerServicePhoneLink />
                from 10&nbsp;am&nbsp;to&nbsp;8&nbsp;pm&nbsp;EST.
              </p>
            </div>
          </div>
          <div class="thankyou-discount">
            <div class="copy">
              <p>
                {{ planInfo.thank_you_discount }}
              </p>
              <a href="/store/" class="button">
                <span class="button-inset"> Shop with 10% OFF </span>
              </a>
            </div>
          </div>
        </section>
      </div>
      <!-- /VINOVEST -->
      <!-- ALL OTHER CLUBS (new design 2024) -->
      <div v-else class="b24">
        <div class="site-width">
          <div class="section club-confirmation">
            <div class="row">
              <div class="columns large-4">
                <img
                  :src="planInfo.thank_you_logo"
                  :alt="planInfo.thank_you_logo_alt"
                />
              </div>
              <div class="columns large-8 end">
                <div class="copy-container">
                  <h1 v-html="planInfo.thank_you_heading"></h1>
                  <div class="copy-main">
                    <p>
                      {{ planInfo.thank_you_description }}
                    </p>
                    <p v-if="planStatusCopy">
                      {{ planStatusCopy }}
                    </p>
                    <p>
                      {{ planInfo.thank_you_discount }}
                    </p>
                  </div>
                  <p>
                    <a href="/store/" class="button m-0">Shop with 10% off</a>
                  </p>
                  <div class="copy-secondary">
                    <p>
                      If you’d like to make changes at any time, or have
                      questions, please don’t hesitate to contact our Napa-based
                      member services team at
                      <CustomerServiceClubEmailLink />
                      or
                      <CustomerServicePhoneLink :with-hours-short="true" />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /ALL OTHER CLUBS -->
    </main>
  </div>
</template>

<script>
export default {
  name: 'ThankYou',
  props: {
    planSlug: {
      type: String,
      default: null,
      required: true,
    },
    isPlanFull: {
      type: Boolean,
      default: false,
      required: false,
    },
    allPlansInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isVinovest() {
      return this.planSlug === 'vinovest-club-mixed'
    },
    planStatusCopy() {
      if (this.isPlanFull) {
        return this.planInfo.thank_you_detail_full
      }
      return this.planInfo.thank_you_detail_active
    },
    planInfo() {
      const plansInfo = this.allPlansInfo.filter(
        (plan) => plan.slug === this.planSlug,
      )
      return plansInfo[0]
    },
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  created() {
    this.metadata = useMetadata()
  },
}
</script>
